class XclsiorFeaturedProducts {
  constructor(section) {
    this.section = section;
    this.cards = [...section.querySelectorAll('[data-product-card]')];
    this.cards.forEach((card) => this.initCard(card));
  }

  initCard(card) {
    const media = card.querySelector('[data-product-media]');
    const overlay = card.querySelector('[data-variant-overlay]');
    const variantsNode = card.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];

    media?.addEventListener('mouseenter', () => media.classList.add('is-image-hovered'));
    media?.addEventListener('mouseleave', () => media.classList.remove('is-image-hovered'));

    const navigate = () => {
      const url = card.dataset.productUrl;
      if (url) window.location.href = url;
    };

    card.addEventListener('click', (event) => {
      if (event.target.closest('button, a, input, select, label, fieldset')) return;
      navigate();
    });

    card.addEventListener('keydown', (event) => {
      if (event.target !== card) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        navigate();
      }
    });

    overlay?.addEventListener('click', (event) => event.stopPropagation());

    const optionButtons = [...card.querySelectorAll('[data-option-value]')];
    optionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const fieldset = button.closest('[data-option-position]');
        const position = Number(fieldset?.dataset.optionPosition || 0);

        fieldset?.querySelectorAll('[data-option-value]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });

        const selectedOptions = [...card.querySelectorAll('[data-option-position]')]
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((group) => group.querySelector('.is-selected')?.dataset.optionValue || '');

        const selectedVariant = variants.find((variant) =>
          selectedOptions.every((value, index) => !value || variant.options?.[index] === value)
        );

        if (selectedVariant) this.updateCard(card, selectedVariant);
      });
    });
  }

  updateCard(card, variant) {
    const sellingPrice = card.querySelector('[data-selling-price]');
    const comparePrice = card.querySelector('[data-compare-price]');

    if (sellingPrice && variant.price != null) {
      sellingPrice.textContent = this.formatMoney(variant.price);
    }

    if (comparePrice) {
      const showCompare = Number(variant.compare_at_price) > Number(variant.price);
      comparePrice.classList.toggle('is-hidden', !showCompare);
      if (showCompare) comparePrice.textContent = this.formatMoney(variant.compare_at_price);
    }

    const image = variant.featured_image?.src || variant.featured_image?.url;
    const primary = card.querySelector('.product-card__image--primary');
    if (image && primary) {
      primary.src = image;
      primary.removeAttribute('srcset');
    }

    card.dataset.variantId = variant.id;
  }

  formatMoney(cents) {
    const value = Number(cents) / 100;
    const currency = window.Shopify?.currency?.active || 'INR';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
      style: 'currency',
      currency
    }).format(value);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.xclsior-featured-products').forEach((section) => {
    new XclsiorFeaturedProducts(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.xclsior-featured-products') || event.target;
  if (section.matches?.('.xclsior-featured-products')) new XclsiorFeaturedProducts(section);
});
